import React from 'react';
import { Controller } from 'react-hook-form';
import useFinancesHook from './finances-hook';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import AutoComplete from '../../../../../Components/Inputs/AutoComplete/autoComplete';
import Button from '../../../../../Components/Button/button';
import AuthInput from '../../../../../Components/Inputs/AuthInput/authInput';
import ToggleSwitch from '../../../../../Components/ToggleSwitch/toggleSwitch';
import styles from './finances.module.scss';

interface IProps {
    companyId: number;
};

const Finances: React.FC<IProps> = ({ companyId }) => {
    const {
        errors,
        control,
        currencies,
        isLoading,
        isButtonActive,
        register,
        updateFinance,
    } = useFinancesHook(companyId)
    const { t, mobileScreen } = useGeneralHooks();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <p>
                    {
                        t('My_Business.Finances.Header')
                    }
                </p>
            </div>
            <form className={styles.form}>
                <div className={styles.formInput}>
                    <p>{t('My_Business.Finances.Currency')}</p>
                    <Controller
                        control={control}
                        name='cost_currency'
                        render={({ field: { onChange, name, value } }) => {
                            return (
                                <AutoComplete
                                    value={value}
                                    name={name}
                                    onChange={onChange}
                                    placeholder={!mobileScreen ? t('My_Business.Finances.Currency_Plh') : undefined}
                                    id='cost_currency'
                                    data={currencies}
                                    showTextError={false}
                                    error={errors.cost_currency}
                                />
                            );
                        }}
                    />
                </div>
                <div className={styles.formInput}>
                    <p>{t('My_Business.Finances.Service_Fee')}</p>
                    <AuthInput
                        register={register}
                        registerName='service_fee'
                        labelStyle={styles.inputLabel}
                        error={errors.service_fee}
                        type='number'
                        required={false}
                        showTextError={false}
                    />
                </div>
                <div className={styles.formItem}>
                    <p>{t('My_Business.Finances.Pos_Terminal')}</p>
                    <ToggleSwitch
                        name="pos_terminal"
                        control={control}
                    />
                </div>
                {isButtonActive && (
                    <div className={styles.buttonRow}>
                        <Button
                            title={t('Buttons.Save')}
                            onClick={updateFinance}
                            type='button'
                            buttonType={ButtonTypes.Primery}
                            buttonStyle={`${styles.button}`}
                            buttonTitleStyle={styles.buttonTitle}
                            isLoading={isLoading}
                        />
                    </div>
                )}
            </form>
        </div>
    )
};

export default Finances
